import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  name: 'network-trip',
  components: {
    VueElementLoading,
    Paginate,
    DatePicker
  },
  props: [],
  data() {
    return {
      hubid: '',
      fromDate: '',
      toDate: '',
      NetworkTripList: [],
      isLoading: false,
      pageCount: 0,
      pageNo: 0,
      createdBy: '',
      tripstate: '',
      totalcount: 0,
      vehicleno: '',
      tripstateError: '',
      modalShow: false,
      schedulemasteridarrr: '',
      connectionnamearrr: '',
      tripId: '',
      IsBtnClick: false
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '-'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.hubid = userdetail[0].HubId;
    this.createdBy = userdetail[0].email;
    this.pageNo = 0;
  },
  methods: {
    bmodalopen(a, b, c) {
      this.tripId = a
      this.schedulemasteridarrr = b
      this.connectionnamearrr = c
      this.modalShow = true;
    },
    bmodalclose() {
      this.tripId = '';
      this.schedulemasteridarrr = '';
      this.connectionnamearrr = '';
      this.modalShow = false;
    },
    getTripDetails(issearch) {
      if (this.tripstate != '' && this.fromDate != '' && this.toDate != '' && this.fromDate != null && this.toDate != null) {
        var fromdate= moment(this.fromDate).format('YYYY-MM-DD')
        var todate = moment(this.toDate).format('YYYY-MM-DD')
        this.tripstateError = ''
        this.NetworkTripList = []
        this.isLoading = true
        axios({
            method: 'GET',
            'url': apiUrl.api_url_hubops + 'getNetworkTripVehiclesListByHubId?HubID=' + this.hubid[0] + '&TripState=' + this.tripstate + '&fromDate=' + fromdate + '&toDate=' + todate + '&VehicleNo=' + this.vehicleno + '&offset=' + this.pageNo + '&limit=10',
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoading = false
            if (result.data.ResultCode == 100) {
              this.NetworkTripList = result.data.ResultData
              this.totalcount = result.data.TotalCount
              this.IsBtnClick = true;
              // if (IsSearch == 1) {
              this.$alertify.success(result.data.ReturnMessage)
              //}
              let totalRows = result.data.TotalCount
              if (totalRows < 10) {
                this.pageCount = 1
              } else {
                this.pageCount = Math.ceil(totalRows / 10);
              }
            } else if (result.data.ResultCode == 101) {
              this.IsBtnClick = false;
              this.NetworkTripList = []
              this.$alertify.error(result.data.ReturnMessage)
            } else {
              this.IsBtnClick = false;
              this.NetworkTripList = []
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.IsBtnClick = false;
            this.isLoading = false
            console.error(error)
          })
      }
			else{
				this.NetworkTripList = []
			}
    },
    closeTrip(data, index) {
      this.input = ({
        "ConnectionScheduleMasterID": data.ConnectionScheduleMasterID,
        "TripID": data.VendorVehicleTripID,
        "HubID": this.hubid[0],
        "CreatedBy": this.createdBy
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'closeNetworkTrip',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.getTripDetails();
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    // checkValidation(){
    // 	this.$validator.validate('TripState1')
    // 	this.$validator.validate('toDate1')
    // 	this.$validator.validate('fromDate1')
    // 	if ((this.tripstate != "" && this.tripstate != null) && (this.fromDate != "" && this.fromDate != null) && (this.toDate != "" && this.toDate != null)) {
    // 		this.getTripDetails();
    // 	}
    // },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.getTripDetails();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getPaginationData(pageNum) {
      this.pageNo = 0
      this.pageNo = (pageNum - 1) * 10;
      this.getTripDetails();
    },
    selectedTripState() {
      this.resetflt(1);
    },
    resetflt(IsSearch) {
      if (IsSearch !== 1) {
        this.tripstate = ''
      }
      this.$validator.reset();
      this.tripId = '';
      this.schedulemasteridarrr = '';
      this.connectionnamearrr = '';
      this.modalShow = false;
      this.IsBtnClick = false;
      this.NetworkTripList = [],
        this.isLoading = false,
        this.totalcount = 0,
        this.vehicleno = '',
        //	this.tripstateError = '',
        this.fromDate = '',
        this.toDate = ''
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/TripManagement/NetworkTrip/NetworkTrip.js